<template>
    <div class="row">
        <div class="col-12 ">
            <np-filter-bar @filter="doFilter" @clear="clearFilter" @change="onQueryChange" :query="filterConfig"
                           :download-url="downloadUrl" v-if="!standalone"></np-filter-bar>
            <np-pagination v-model="filter" :has-data="hasData" v-if="!standalone && !no_pagination" :count="!!table_data ? table_data.length : 0"></np-pagination>
            <np-preloader v-show="loading"></np-preloader>

            <table class="table filter_contentTable" ref="filter_data">
                <colgroup>
                    <col :class="'col-md-' + group" v-for="group in colgroup">
                </colgroup>
                <thead>
                <tr>
                    <template v-for="column in columns">
                        <th v-if="!!column.children && column.children.length > 0" :colspan="column.children.length"  class="text-center">
                            <p class="row clearfix" v-if="column.name != ''">
                                <span class="col-md-12">{{column.name.toUpperCase()}}</span>
                            </p>
                            <p class="row clearfix">
                                <span :class="child_column.class" v-for="child_column in column.children">
                                     {{child_column.name.toUpperCase()}}
                                </span>
                            </p>
                        </th>
                        <th v-else><span>{{column.name.toUpperCase()}}</span></th>
                    </template>
                    <th v-if="buttons.length !== 0" style="text-align:right;padding-right:2.5rem;"><a href="#">{{lang('action').toUpperCase()}}</a></th>
                </tr>
                </thead>
                <transition-group name="list" tag="tbody">
                    <tr class="filter_noDataRow" v-if="!table_data || table_data.length == 0" key="datum_header">
                        <td :colspan="colgroup.length" class="filter_noData"><i class="fa fa-info-circle iconBlue"></i>
                            Sorry! No Data Found.
                        </td>
                    </tr>
                    <template v-for="(datum, index) in table_data" :key="'datum_' + index">
                        <tr  :ref="'datum_' + index">
                            <template v-for="(column, column_index) in columns">
                                <td v-if="column.template !== 'array'" :class="column.class">
                                    <span @click="toggleCollapsibleViews" :data-index="index" v-if="column_index == 0 && show_row_details"><i class="fa fa-plus-square" aria-hidden="true"></i></span>
                                    <span @click="showPopUpModal(datum)" :data-index="index" v-if="column_index == 0 && show_popup_details"><i class="fa fa-plus-square" aria-hidden="true"></i></span>
                                    <span v-if="column.iconClass" v-tooltip.left="column.iconTooltip(datum)" style="min-width:15px; display:inline-block">
                                        <i :class="column.iconClass(datum)"></i>
                                    </span>

                                    <span v-if="column.template == 'bool'">
                                        <np-bool :value="datum[column.key]"></np-bool>
                                    </span>

                                    <span v-else-if="column.template == 'date_time'">
                                        <np-date :value="datum[column.key]"></np-date>
                                    </span>


                                    <span v-else-if="column.template == 'date'">
                                        <np-date :value="datum[column.key]" :type="'date'"></np-date>
                                    </span>

                                    <span v-else-if="column.template == 'currency'">
                                        <np-date :value="currency([column.key], curr, dec)"></np-date>
                                    </span>

                                    <span v-else-if = "column.type==='custom'" v-html="column.formatter(datum)">
                                    </span>

                                    <span v-else-if="column.iconClass" v-tooltip.left="column.iconTooltip(datum)" style="min-width:15px; display:inline-block">
                                        <i :class="column.iconClass(datum)"></i>
                                    </span>
                                    <!-- deprecated -->
                                    <a v-else-if="column.type==='link' && datum.href"
                                       style="text-decoration: underline !important;"
                                       :href="datum.href">
                                        {{defaultFormat(datum[column.key])}}
                                    </a>
                                    <a v-else-if="column.href && column.href(datum)"
                                       style="text-decoration: underline !important;"
                                       :href="column.href(datum)">
                                        {{defaultFormat(datum[column.key])}}
                                    </a>
                                    <span v-else>
                                        <span v-if="column.formatter && column.key" v-html="column.formatter(datum[column.key])"></span>
                                        <span v-else-if=column.key v-html="defaultFormat(datum[column.key])"></span>
                                    </span>
                                </td>
                                <td v-else :colspan="column.children.length" >
                                    <template>
                                        <table style="width: 100%">
                                            <colgroup>
                                                <col :class="child_col.class" v-for="child_col in column.children">
                                            </colgroup>
                                            <tr v-for="(array_data, data_index) in datum[column.key]">
                                                <td v-for="(subcolumn, subcolumn_index) in column.children" :class="!!column.class ? column.class : ''" scope="colgroup">{{array_data[subcolumn.key]}}</td>
                                            </tr>
                                        </table>
                                     </template>
                                </td>
                            </template>
                            <td v-if="(buttons.length !== 0) && getCurrentButtons(index).length > 0" style="">
                                <div class="optionBtn pull-right" href="#" v-if="getCurrentButtons(index).length > 1">
                                    <a class="btn btn-sm btn-default btn-with-label">
                                        <i class="fa fa-bars"></i>
                                        <span class="btn-label">
                                        <i class="fa fa-caret-down"></i>
                                    </span>
                                    </a>
                                    <ul>
                                        <li v-for="btn in getCurrentButtons(index)">
                                            <a @click="btn.callback(datum)" :href="btn.href(datum)" v-bind="btn.attributes(datum)" v-if="btn.href(datum) != '#'">
                                                <i :class="btn.iconClass"></i> {{lang(btn.name)}}
                                            </a>
                                            <a @click.prevent="btn.callback(datum)" :href="btn.href(datum)" v-bind="btn.attributes(datum)" v-else>
                                                <i :class="btn.iconClass"></i> {{lang(btn.name)}}
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                                <div class="optionBtn pull-right" href="#" v-else-if="getCurrentButtons(index).length === 1">
                                    <a class="btn btn-default btn-sm createdBtn btn-with-label" v-for="btn in getCurrentButtons(index)" @click="btn.callback(datum)" :href="btn.href(datum)" v-bind="btn.attributes(datum)">
                                        <div class="btn-label"><i :class="btn.iconClass"></i></div> {{lang(btn.name)}}
                                    </a>
                                </div>
                                <div v-else>
                                    -
                                </div>
                            </td>
                            <td v-else-if="(buttons.length !== 0) && getCurrentButtons(index).length === 0" style="">
                                <span class="pull-right">-</span>
                            </td>
                        </tr>
                        <np-filter-collapsible-display
                                :key="'collapsible_block_' + index"
                                :ref="'collapsible_block_' + index"
                                v-if="show_row_details"
                                v-show="true"
                                :colgroup="colgroup"
                                :dispay_data="datum"
                                :show="false">
                        </np-filter-collapsible-display>
                    </template>
                </transition-group>
            </table>
            <np-preloader v-show="loading" v-if="table_data && table_data.length > 20"></np-preloader>
        </div>
        <div class="col-12">
            <np-filter-pop-up-display
                    :id="`filter_modal`"
                    :ref="`filter_modal`"
                    :display_data="pop_up_data"
                    :use_pop_slot="use_pop_slot"
                    :title="pop_up_header">
                <slot v-bind:pop_up_data="pop_up_data" name="np_filter_modal" slot="np_filter_modal" v-if="use_pop_slot" >
                    {{pop_up_data}}
                </slot>
            </np-filter-pop-up-display>
        </div>
    </div>
</template>

<script>
    import NPFilterBar from './np-filter-bar.vue';
    import NPPagination from './np-pagination.vue';
    import NPCollapsibleDisplay from './np-filter-collapsible-display.vue';
    import NPFilterPopUpDisplay from './np-filter-pop-up-display.vue';
    import NPDate from '../np-date.vue';
    import _ from 'lodash';
    import NPPreloader from '../np-preloader.vue';
    import NPBool from '../np-bool.vue';

    export default {
        name: "np-filter-widget",
        //introduction: "This is a filter widget able to render grid table data",
        description: "Each column rendering can be customised based on formatter, links support per column, filter and order support.",
        token: `<np-filter-widget :columns="[
                    {name:lang('ext_mid'), key:'ext_mid'},
                    {name:lang('ext_transaction_date'), key:'ext_transaction_date', formatter: date},
                    {name:lang('amount_total_merchant'), key:'amount_total_merchant', formatter: currency}
                    {name:lang('calculated'), key:'calculated', template: 'bool'},
                ]"
                      url="/transaction/filter"
                      :buttons="['view']"
                      :table_data="transactions" @update:table_data="(val) => { transactions = val.transactions }"
                      :saved_query="saved_query"
                      @query-change="updateSearchOptions"
                      :searchable="['ext_mid', {type:'select', name:'calculated', options: calculated_options, dependent_on: string || array }]"
                      :hidden_filters="{'name1':'value1', 'name2':'value2'}"
                      :colgroup="['08p', '015p', '013p']"
                      @view="viewTransaction"></np-filter-widget>`,

        props: {
            columns: {
                type: Array,
                note: 'Columns list that will create table grid'
            },
            fetchOnCreation: {
                type: Boolean,
                default: () => false,
            },
            use_pop_slot: {
                type: Boolean,
                default: () => false,
            },
            show_row_details: {
                type: Boolean,
                default: () => false,
            },
            show_popup_details: {
                type: Boolean,
                default: () => false,
            },
            standalone: {
                type: Boolean,
                default: () => false,
            },
            no_pagination: {
                type: Boolean,
                default: () => false,
            },
            excludeDefaultDate: {
                type: Boolean,
                default: () => false,
            },
            colgroup: {
                type: Array,
                note: 'Column groups'
            },
            table_data: {
                type: Array,
                note: 'Data that will be displayed in the table'
            },
            saved_query: {
                type: Object,
                required: true,
                note: 'Search Query stored in session data'
            },
            buttons: {
                type: Array,
                default: function () {
                    return ['view', 'edit']
                },
                note: 'Buttons we render against each table item. Can be string literal as button name or object for extra config(See showButton() function)'
            },
            searchable: {
                type: Array,
                note: 'Searchable field list'
            },
            hidden_filters: {
                type: Object,
                note: 'Hidden search elements'
            },
            beforeSubmit: Function,
            url: {
                type: String,
                note: 'Endpoint used for retrieve data call'
            },
            cursor: {
                type: String,
                default: () => '',
                note: 'Pass data key in filter request'
            },
            downloadUrl: {
                type: String
            },
            bus: {
                type: Object,
                note: 'Optionally specify event bus'
            },
            // slotName: {
            //     type: String,
            //     default: () => '',
            //     note: 'Pass name for filter slot'
            // },
            pop_up_header: '',
            pop_up_buttons: {
                type: Array,
                default: function () {
                    return []
                },
                note: 'Buttons'
            }
        },
        data: function () {
            return {
                filter: {
                    limit: 15,
                    page: 1,
                    next: true
                },
                pop_up_data:  {},
                loading: false,
                currentButtonList: [],
                old_query: {},
                autoSearchTimeoutId: null,
                modalAttached: false,
                //query$: Object,
            }
        },
        created: function() {
            const vm = this;
            if (this.bus) {
                this.bus.$on('refresh', function () {
                    vm.clearFilter();
                })
            }
            if (this.fetchOnCreation) {
                this.clearFilter(); // Auto fetch data on create
            }
        },
        computed: {
            hasData: function() {
                // return this.table_data && this.table_data.length > 0 && (this.table_data.length > this.filter.limit);
                return this.table_data && this.table_data.length > 0; // && (this.table_data.length > this.filter.limit);
            },
            translationEnabled: function () {
                // NOT IDEAL SOLUTION
                let {CAN_TRANSLATE} = !!vue_data.parameters ? vue_data.parameters : {};
                return this.$attrs && this.$attrs.onTranslate && !!CAN_TRANSLATE;
            },
            buttonsConfig: function() {
                const config = [];
                let buttons = this.buttons;
                if (!buttons) buttons = ['view', 'edit'];

                const vm = this;
                this.buttons.forEach(btn => {
                    if (typeof btn === 'string') {
                        config.push({
                            name: btn,
                            callback: data => {vm.$emit(btn, data)},
                            href: () => '#',
                            iconClass: btn === 'view' ? 'flaticon-filterview' : btn === 'delete' ? 'fa fa-trash-o' : 'fa fa-pencil',
                            shouldDisplay: () => true,
                            attributes: () => {}
                        })
                    } else if (typeof btn === 'object') {
                        const defaultIconClass = btn.name === 'view' ? 'flaticon-filterview' : btn === 'delete' ? 'fa fa-trash-o' : 'fa fa-pencil'
                        config.push({
                            name: btn.name,
                            callback: btn.callback ? btn.callback: data => vm.$emit(btn.name, data),
                            href: btn.href ? btn.href : () => '#',
                            iconClass: btn.iconClass ? btn.iconClass : defaultIconClass,
                            shouldDisplay: btn.shouldDisplay? btn.shouldDisplay: () => true,
                            attributes: !!btn.attributes? btn.attributes : () => {}
                        })
                    }
                });
                return config;
            },
            filterConfig: function () {
                const config = [];
                this.searchable.forEach(cfg => {
                    if (typeof cfg === "string") {
                        config.push({
                            name: cfg,
                            type: 'text',
                            value: (!!this.saved_query && !!this.saved_query[cfg]) ? this.saved_query[cfg] : '',
                            rules: {},

                        })
                    } else {
                        const default_value = (!!this.saved_query && !!this.saved_query[cfg.name]) ? this.saved_query[cfg.name] : '';
                        config.push({
                            name: cfg.name,
                            type: cfg.type,
                            value: !!default_value ? default_value : cfg.default ? cfg.default : '',
                            options: cfg.options,
                            placeholder: cfg.placeholder,
                            dependent_on: !!cfg.dependent_on ? cfg.dependent_on : '',
                            format: !!cfg.format ? cfg.format : '',
                            rules: {}
                        });
                    }
                });
                const names = config.map(cfg => cfg.name);
                if(!this.excludeDefaultDate) {
                    if (!_.includes(names, 'date_from')) {
                        config.push({name:'date_from', type: 'date', value: !!this.saved_query['date_from'] ? this.saved_query['date_from'] : ''});
                    }
                    if (!_.includes(names, 'date_to')) {
                        config.push({name:'date_to', type: 'date', value: !!this.saved_query['date_to'] ? this.saved_query['date_to'] : ''});
                    }
                }
                return config;
            }
        },
        methods: {
            setActiveRow: function (e, ref) {
                let elem = this.$refs[ref][0];

                if(!e.ctrlKey) {
                    let filter = this.$refs['filter_data'];
                    $(filter).find('tr').removeClass('is-active');
                }
                $(elem).toggleClass('is-active');
            },
            toggleCollapsibleViews: function (e) {
                const index = e.currentTarget.getAttribute('data-index');
                const collapsible_block = this.$refs['collapsible_block_' + index][0];
                const classLists = e.target.classList;
                if (classLists.contains('fa-plus-square')) {
                    classLists.add('fa-minus-square');
                    classLists.remove('fa-plus-square');
                    collapsible_block.showCollapsibleBlock(true);
                    $(this.$refs.modal).modal('show');
                    // collapsible_block.style.verticalAlign = "inherit";
                    // collapsible_block.style.borderColor = "inherit";
                } else {
                    classLists.add('fa-plus-square');
                    classLists.remove('fa-minus-square');
                    collapsible_block.showCollapsibleBlock(false);
                }
            },
            showPopUpModal: function (data) {
                this.pop_up_data = data;
                if(!this.modalAttached) {
                    $(this.$refs.filter_modal.$el).on('shown.bs.modal', function () {
                        objCommon.onScreenConfirmation();
                    });
                    this.modalAttached = true;
                }
                this.$refs.filter_modal.show();
            },
            showButton: function(name, data) {
                if (this.buttons) {
                    for (let i = 0; i < this.buttons.length; i++) {
                        const config = this.buttons[i];
                        if (typeof config === 'string' && config === name) {
                            return true;
                        } else if (typeof config === 'object' && config.name === name) {
                            return config.condition(data);
                        }
                    }
                    return false;
                } else {
                    return true;  // show all buttons by default
                }
            },
            defaultFormat: function (text) {
                if(!isNaN(text) && text !== '') {
                    return text;
                }
                return text && text.length > 0 ? text.replace(/ /g, '&nbsp') : '-';
            },
            clearFilter: function () {
                this.$emit('query-change', {});
                this.filter.page = 1;
                this.search({});
            },
            doFilter: function(query) {
                this.filter.page = 1;
                this.search(query);
            },
            handleError: function() {
            },
            getCurrentButtons: function (index) {
                let rowData =  this.table_data[index];
                let vm = this;
                let buttonList = this.buttonsConfig.filter((obj) => { return obj.shouldDisplay(rowData);});
                if(!!vm.translationEnabled) {
                    buttonList.push({
                        name: 'translate',
                        callback: data => {vm.$emit('translate', data); },
                        href: () => '#',
                        iconClass: 'fa fa-language',
                        shouldDisplay: () => true,
                        attributes: () => {}
                    })
                }
                // this.currentButtonList = buttonList;
                return buttonList;
            },
            onQueryChange: function(query, emit = true) {
                let vm = this;
                if(emit) {
                    this.$emit('query-change', query, $event, filterData);
                }
                // Reset filter page to initial page on data refresh
                // vm.filter.page = 1;
                if (this.autoSearchTimeoutId !== null) {
                    clearTimeout(this.autoSearchTimeoutId);
                    this.autoSearchTimeoutId = null;
                }
                this.autoSearchTimeoutId = setTimeout(() => {
                    if (!_.isEqual(this.old_query, query)) {
                        this.search(query);
                    }
                }, 1000);
            },
            search: function (query) {
                if (this.beforeSubmit) {
                    query = this.beforeSubmit(query);
                }
                this.old_query = query;
                const filterdata = Object.assign(this.filter, this.hidden_filters);
                var post_data = _.clone(filterdata);
                for(var key in query) {
                    post_data[key] = query[key];
                }
                // Add cursor to table data if it has been sent
                let table_data_length = !!this.table_data ? this.table_data.length : 0;
                if (filterdata.hasOwnProperty('pagination_event') && filterdata.pagination_event) { //only use cursor when we have next or previous page click
                    if (this.cursor !== '' && table_data_length > 0) {
                        if (this.filter.next) {
                            post_data[this.cursor] = this.table_data[table_data_length - 1][this.cursor];
                        } else {
                            post_data[this.cursor] = this.table_data[0][this.cursor];
                        }
                    }
                }

                const vm = this;
                this.loading = true;
                this.getAxiosInstance().post(this.url, post_data)
                    .then(function (response) {
                        const data = response.data;
                        if (data.result === 'ERROR') {
                            vm.$emit('update:table_data', []);
                            if (typeof objCommon !== "undefined") {
                                objCommon.showCustomValidationError(' ' + data.error.explanation);
                            }
                        } else {
                            vm.$emit('update:table_data', data);
                            //vm.table_data = data;
                            // todo: Edge finally
                            vm.loading = false;
                        }
                    })
                    .catch(function (error) {
                        // todo: Edge finally
                        vm.loading = false;
                        vm.handleAjaxError(error, 'Filter Error: Unknown filter error');
                    })
                    .finally(function () {
                        vm.loading = false;
                    });
            }

        },
        watch: {
            filter: function (newValue) {
                this.search(this.old_query);
            },
            url: function (newValue) {
                this.search(this.old_query);
            }
        },
        components: {
            'np-filter-bar': NPFilterBar,
            'np-pagination': NPPagination,
            'np-date': NPDate,
            'np-preloader': NPPreloader,
            'np-bool': NPBool,
            'np-filter-collapsible-display': NPCollapsibleDisplay,
            'np-filter-pop-up-display': NPFilterPopUpDisplay
        }
    }
</script>
<style scoped>
    .is-active {
        background: #dadee4;
    }
    /*
    *
    .list-enter-active, .list-leave-active {
        transition: all 1s;
    }
    .list-enter, .list-leave-to {
        opacity: 0;
    }
    .list-leave-to {
       z-index: -1;
    }
    .list-enter {
        transform: translateY(-50px);
    }
    .list-leave-to {
        z-index:-1;
        transform: translateY(50px);
    }
    **/
</style>
